// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__35VZj","col":"styles_col__1QF9c"};